// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyB39kMiH1ZZLjd4O6ePtJo5iPA8unwqlvE',
    authDomain: 'dreamchain.firebaseapp.com',
    projectId: 'dreamchain',
    storageBucket: 'dreamchain.appspot.com',
    messagingSenderId: '924640594571',
    appId: '1:924640594571:web:9550b75cee1f44a4d2628e',
    measurementId: 'G-WFVF5CR0ML',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
